import React , { useState }from 'react';
import AboutUs from '../components/AboutUs';




import { Link } from 'react-router-dom';


const AboutUsPage: React.FC = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {/* <Navbar /> */}
      <header className="navbar">
      <div className="navbar-logo">Qualak</div>
      <nav className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          {/* <li><a href="/AboutUs">About</a></li> */}
          <li><Link to="/">Home</Link></li>
          {/* <li><a href="#careers">Careers</a></li> */}
          {/* <li><a href="#news">News</a></li> */}
          
        </ul>
      </nav>
      <div className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </header>

      <AboutUs />
      
      {/* Custom footer */}
      <div className="footer" id = "contact">
      {/* Top Row: Contact Us and Links */}
      <div className="footer-top">
        <div className="footer-left">
          <h2>Contact Us</h2>
          <p>Email: <a href="mailto:burak@qualak.com" className="email-link">burak@qualak.com</a></p>
        </div>
        <div className="footer-right">
          <div className="quick-links">
            {/* <a href="https://twitter.com/qualak" target="_blank" rel="noopener noreferrer">Twitter </a>
            <a href="https://linkedin.com/company/qualak" target="_blank" rel="noopener noreferrer">LinkedIn </a>
            <a href="https://github.com/qualak" target="_blank" rel="noopener noreferrer">GitHub </a> */}
            {/* <a href="/">Home</a>   */}

          </div>
        </div>
      </div>

      {/* Bottom Row: Footer Bottom Text */}
      <div className="footer-bottom">
        <div className='social-links'>
          <a href="https://x.com/qualak_official" target="_blank" rel="noopener noreferrer"> X </a> | 
          <a href="https://www.linkedin.com/company/qualak/about/" target="_blank" rel="noopener noreferrer"> LinkedIn </a>
          </div>

        <p>&copy; 2024 Qualak OÜ. All rights reserved.</p>
      </div>
    </div>
    </>
  );
};

export default AboutUsPage;
